module.exports = __webpack_public_path__ + "static/media/location.f83c4d3c.svg";